import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const professionalLandlordHelp: AppContent['professionalLandlordHelp'] = {
  metaContent: {
    title: MetaContentValues.professionalLandlordHelp.title,
  },
  backLabel: 'Back to Landlord support',
  title: 'Professional landlord help',
  whenYoureALandlord:
    "When you're a landlord, there are times when only the professionals will do. Find out what you need to know when picking someone to help you.",
  lettingAgents: {
    title: 'Letting agents',
    lotsOfLandlords:
      "Lots of landlords use a letting agent because it makes looking after their rental property easier. They can find tenants, collect rent, sort out tradespeople, and make sure everything's up to date. Usually, they take a fee from your monthly rent for their services.",
    beforeYouChoose:
      'Before you choose a letting agent, ask around for recommendations from other landlords you know. Then get some quotes to compare.',
    allAgents: 'All letting agents in England and Wales must join a ',
    redressLinkLabel: 'redress scheme',
    redressLinkHref: 'https://www.gov.uk/redress-scheme-estate-agencies',
    andA: ' and a ',
    clientMoneyLinkLabel: 'client money protection scheme',
    clientMoneyLinkHref:
      'https://www.gov.uk/client-money-protection-scheme-property-agents',
    period: '.',
    checkIfRegisteredLinkLabel:
      'Check if a letting agent in England or Wales is registered',
    checkIfRegisteredLinkHref:
      'https://www.nationaltradingstandards.uk/property-agent-checker',
    agentsInScotland:
      'Letting agents in Scotland have to follow a Letting Agent Code of Practice and be registered on the ',
    scottishAgentRegisterLinkLabel: 'Scottish Letting Agent Register',
    scottishAgentRegisterLinkHref:
      'https://register.lettingagentregistration.gov.scot/search',
    northernIreland: 'In Northern Ireland, ',
    agentsMustBeRegisteredLinkLabel: 'letting agents must be registered',
    agentsMustBeRegisteredLinkHref:
      'https://www.nidirect.gov.uk/articles/landlord-registration-scheme',
    partOfRedressScheme:
      " and be part of a redress scheme. But they don't have to join a client protection money scheme.",
  },
  accountants: {
    title: 'Accountants',
    havingAnAccountant:
      'Having an accountant can be useful, especially if you have multiple rental properties and different incomes. They can make sure you pay the right amount of tax when you need to pay it by.',
    askAround:
      'Again, ask around for recommendations from other landlords you know. Then get some quotes to compare.',
    noOfficialBody:
      "There's no official body or organisation accountants need to belong to. However, it can be worth employing a chartered accountant, as it gives you extra protection if you get any bad advice.",
    charteredAccountantsTitle:
      'Chartered accountants will be members of one or more of these professional bodies:',
    charteredAccountantsListItems: [
      'Association of Chartered Certified Accountants (ACCA)',
      'Chartered Institute of Management Accountants (CIMA)',
      'Chartered Institute of Public and Finance Accountancy (CIPFA)',
      'Institute of Chartered Accountants in England and Wales (ICAEW)',
      'The Institute of Chartered Accountants of Scotland (ICAS)',
      'Chartered Accountants Ireland (Northern Ireland)',
    ],
  },
  solicitors: {
    title: 'Solicitors',
    beingALandlord:
      'Being a landlord comes with a lot of legal responsibilities. It can be costly if you fall foul of the rules, so having a solicitor on-hand can reduce your risk of being fined or worse.',
    findSolicitorEnglandLinkLabel: 'Find a solicitor in England and Wales',
    findSolicitorEnglandLinkHref: 'https://solicitors.lawsociety.org.uk/about',
    findSolicitorScotalndLinkLabel: 'Find a solicitor in Scotland',
    findSolicitorScotlandLinkHref:
      'https://www.lawscot.org.uk/find-a-solicitor',
    findSolicitorNortherIrelandLinkLabel:
      'Find a solicitor in Northern Ireland',
    findSolicitorNorthernIrelandLinkHref:
      'https://lawsoc-ni.org/using-a-solicitor/find-a-solicitor',
  },
};

export default professionalLandlordHelp;
